import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class HiddenEntityStack extends Component {
    static propTypes = {
        hide: PropTypes.bool.isRequired,
        toggleEntityStack: PropTypes.func.isRequired,
    }

    handleToggleEntityStack = () => {
        const { toggleEntityStack } = this.props

        toggleEntityStack()

        // Delay the resize event until the entityStack animation (500ms) is finished
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 650)
    }

    render() {
        const { hide } = this.props

        return <div className={cx('entity-stack-hidden-tab', hide && 'hide')} onClick={this.handleToggleEntityStack} />
    }
}
